import type { PosthogEventName, PosthogEventPayloads } from './events';
import { posthog } from '@/lib/posthog/posthog';

export function trackEvent<K extends PosthogEventName>(
  event: K,
  properties: PosthogEventPayloads[K]
) {
  posthog.capture(event, properties);
}
